import {MainLayout} from "@/layouts/main/index.js";
import CatalogSection from '@/widgets/catalog/CatalogSection/CatalogSection.jsx'
import HeroSection from "@/widgets/catalog/HeroSection/HeroSection.jsx";

export default function CatalogWidget() {
    return (
        <MainLayout>
            <HeroSection />
            <CatalogSection />
        </MainLayout>
    )
}